import React from "react";
import { Input } from "reactstrap";

// Casilla de palomita que estampa sola la fecha en que se marco.
// El dato vive en el MISMO campo de texto que ya existia: vacio/"NA" = sin palomita,
// una fecha = palomeado ese dia. Por eso no hubo que tocar modelos ni validadores.
export const hoyISO = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// Cualquier valor distinto de vacio y de "NA" cuenta como marcado: asi los textos
// viejos ("SI", "OK", "P") que ya esten capturados siguen apareciendo palomeados.
export const palomeado = (v) => !!v && v !== "NA";

const ES_FECHA = /^\d{4}-\d{2}-\d{2}$/;
// color de lo que el sistema llena solo
export const COLOR_AUTO = "#2563eb";

// `auto`: fecha que el sistema ya sabe (por ejemplo, cuando se subio la ficha
// tecnica). Si nadie palomeo a mano, la casilla sale marcada con esa fecha en azul.
export const CheckFecha = ({ valor, onChange, auto }) => {
  const usaAuto = !palomeado(valor) && palomeado(auto);
  const mostrado = usaAuto ? auto : valor;
  const marcado = palomeado(mostrado);
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
      <Input
        type="checkbox"
        checked={marcado}
        title={usaAuto ? `Automatic: ${auto}` : marcado ? `Checked on ${valor}` : "Not checked yet"}
        style={{ position: "static", margin: 0, marginLeft: 0, cursor: "pointer", width: 16, height: 16 }}
        onChange={(e) => onChange(e.target.checked ? hoyISO() : "")}
      />
      {marcado ? (
        // en ambar cuando lo que hay no es una fecha (captura vieja hecha a mano)
        <small style={{ fontSize: "0.66rem", lineHeight: 1.1, color: usaAuto ? COLOR_AUTO : ES_FECHA.test(valor) ? "#64748b" : "#b45309" }}>
          {mostrado}
        </small>
      ) : null}
    </div>
  );
};

export default CheckFecha;
